import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedPopupService } from './services/popup.service';
import { SharedUtilsService } from './services/utils.service';
import { NotificationService } from './services/notification.service';

@NgModule({
  imports: [CommonModule],
  providers: [SharedPopupService, SharedUtilsService, NotificationService]
})
export class SharedModule {}
